import { gql } from '@apollo/client';

export const QUOTE_CASH_BACK_AMOUNT_FRAGMENT = gql`
  fragment QuoteCashBackAmountFields on QuoteCashBackAmountResponse {
    amount
    description
    equipmentId
  }
`;
